module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "aws_gov-logo.74a59d52.png";